import {
  ProfileCard,
  ProfileCardHeader,
  ProfileLineWrapper,
} from "@/pages/profile/components/atom";
import { ProfileLine } from "@/pages/profile/components/profile-line";
import UnbindModal from "@/pages/profile/components/action-modal/unbind-modal";
import { useTranslation, Trans } from "react-i18next";
import { useFoxMediaLink } from "@/pages/profile/hooks/useFoxMediaLink";
import styled from "styled-components";
import { FoxMediaLink } from "@/pages/profile/constant/fox-meda-link";

export function FoxThreePartyLink() {
  const { t } = useTranslation("profile");

  const {
    bindList,
    bindAccount,
    openUnbindModal,
    setOpenUnbindModal,
    bindAccountMeta,
  } = useFoxMediaLink();
  const { t: commonT } = useTranslation("common");

  return (
    <TreePartyWrapper>
      <ProfileCardHeader>{t("fox_user_media_link_title")}</ProfileCardHeader>
      <ProfileLineWrapper>
        {bindList.map((item) => {
          const metaInfo = bindAccountMeta[item.type as FoxMediaLink];
          return (
            <ProfileLine
              key={item.type}
              title={metaInfo?.name}
              extra={
                <NickName>
                  {item.nickname || t("fox_user_media_no_bound")}
                </NickName>
              }
              noneTip={t("fox_user_media_unlink")}
              actionClass={!!item.id ? "unbind" : ""}
              action={[
                <div
                  key={item.type}
                  onClick={() => {
                    if (item.nickname) {
                      setOpenUnbindModal(true);
                      return;
                    }
                    bindAccount(item.type);
                  }}
                >
                  {item.nickname
                    ? (t("fox_user_media_unlink") as string)
                    : (t("fox_user_media_link") as string)}
                </div>,
              ]}
            />
          );
        })}
        <UnbindModal
          modalProps={{
            width: 600,
            type: "text",
            title: t("fox_user_media_unlink_title"),
            children: (
              <TipContent>
                <Trans i18nKey="fox_user_media_unlink_content" t={t} />
              </TipContent>
            ),
            open: openUnbindModal,
            onCancel: () => setOpenUnbindModal(false),
            okText: commonT("common_sure"),
            footer: (_, { OkBtn }) => <OkBtn />,
            onOk: async () => {
              setOpenUnbindModal(false);
            },
          }}
        />
      </ProfileLineWrapper>
    </TreePartyWrapper>
  );
}

const NickName = styled.div`
  color: #757879;
  line-height: 22px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TreePartyWrapper = styled(ProfileCard)``;

export const TipContent = styled.div`
  width: 445px;
  height: 130px;
  background: #2c2c31;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 30px auto 0;
  color: #bfc2c3;
`;
